/** 密码页相关：localStorage 键与预期密码（从根目录 app-config.json 读取） */
import appConfig from '../../app-config.json'

export const UNLOCK_STORAGE_KEY = 'appUnlockPassword'
export const UNLOCK_EXPECTED_PASSWORD = appConfig.unlockPassword

export function isUnlocked() {
  return localStorage.getItem(UNLOCK_STORAGE_KEY) === UNLOCK_EXPECTED_PASSWORD
}
